import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import {DialogModule} from 'primeng/dialog';
import {InputTextModule} from 'primeng/inputtext';
import {ToastModule} from 'primeng/toast';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import {MessageService, ConfirmationService} from 'primeng/api';
import {AttributesService} from '../../../core/services/attributes.service';
import {Brand} from '../../../shared/models/Attribute';

@Component({
  selector: 'app-brands-admin',
  standalone: true,
  imports: [CommonModule, FormsModule, TableModule, ButtonModule, DialogModule, InputTextModule, ToastModule, ConfirmDialogModule],
  providers: [MessageService, ConfirmationService],
  templateUrl: './brands-admin.html',
  styleUrls: ['./brands-admin.css']
})
export class BrandsAdminComponent implements OnInit {
  brands: Brand[] = [];
  brand: Partial<Brand> = {};
  dialog: boolean = false;
  submitted: boolean = false;

  constructor(private service: AttributesService, private messageService: MessageService, private confirmationService: ConfirmationService, private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.service.getBrands().subscribe(data => {this.brands = data; this.cdr.detectChanges()});
  }

  openNew() {
    this.brand = {isActive: true};
    this.submitted = false;
    this.dialog = true;
  }

  edit(item: Brand) {
    this.brand = {...item};
    this.dialog = true;
  }

  save() {
    this.submitted = true;
    if (this.brand.name?.trim()) {
      const req = this.brand.id
        ? this.service.updateBrand(this.brand.id, this.brand as Brand)
        : this.service.createBrand(this.brand as Brand);

      req.subscribe(() => {
        this.messageService.add({severity: 'success', summary: 'Éxito', detail: 'Marca guardada'});
        this.load();
        this.dialog = false;
      });
    }
  }

  toggle(item: Brand) {
    this.confirmationService.confirm({
      message: `¿Cambiar estado de ${item.name}?`,
      header: 'Confirmar Estado',
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.service.toggleBrand(item.id).subscribe(() => this.load())
    });
  }
}
